export const defaultNirResultsWheatCodeFilters: any = () => ({
  filters: [{ field: 'status.name', operator: 'neq', value: 'Out of Stock' }],
  sort_by: [],
  sort_desc: [],
})
